//-------------------------------------------------------------------------------------
// --- Configuration ---
//-------------------------------------------------------------------------------------
const config = {
  selectors: {
    popupMain: '#sct-timer-85485',
    popupFallback: '#sct-timer-84846',
    container: '.sct-popup-container',
    closeBtn: '.sct-timer-close-btn',
    messageTop: '[data-editable="message-before-countdown"]',
    messageBottom: '[data-editable="message-after-countdown"]',
    emailCapture: '.sct-timer-email-capture',
    submitButton: '.email-button',
  },
  targetLocation: {
    countries: ['CA', 'IN'],
    regions: ['Ontario', 'Uttar Pradesh2'],
  },
  googleScriptURL: 'https://script.google.com/macros/s/AKfycbwpzJqTyZvLxYebXCzasRWIFY1LtFY7UM2e4R8fcldpF4ZcleTUoglnG6EILa7K8fC7/exec',
  emailJS: {
    publicKey: 'n28TYS6YIMuHCnods',
    serviceID: 'helpdesk_gmail',
    templateID: 'send_confirmation',
  }
};

//-------------------------------------------------------------------------------------
// --- Utility Functions ---
//-------------------------------------------------------------------------------------
function waitForElement(selector, callback) {
  const observer = new MutationObserver((_, obs) => {
    const el = document.querySelector(selector);
    if (el) {
      console.log(`Element found: ${selector}`);
      obs.disconnect();
      callback(el);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

//-------------------------------------------------------------------------------------
// --- Geolocation Logic ---
//-------------------------------------------------------------------------------------
async function getGeolocationData() {
  console.log('Fetching geolocation data...');
  const ipData = await fetch('https://ipinfo.io/json').then(r => r.json());
  console.log(`Detected IP: ${ipData.ip}`);
  const geoData = await fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?ip=${ipData.ip}&localityLanguage=en`).then(r => r.json());
  console.log(`Country: ${geoData.countryCode}, Region: ${geoData.principalSubdivision}`);
  return { country: geoData.countryCode, region: geoData.principalSubdivision };
}

//-------------------------------------------------------------------------------------
// --- Popup Display Logic ---
//-------------------------------------------------------------------------------------
function showMainPopup(popup) {
  console.log('Target location matched. Showing main popup.');
  popup.style.display = 'block';
  document.querySelector(config.selectors.popupFallback).style.display = 'none';
  bindRegisterNowButton();
}

function showFallbackPopup() {
  console.log('Not a target location. Showing fallback popup.');
  document.querySelector(config.selectors.popupMain).style.display = 'none';
  document.querySelector(config.selectors.popupFallback).style.display = 'block';
}

//-------------------------------------------------------------------------------------
// --- Form Setup ---
//-------------------------------------------------------------------------------------
function injectFormFields(container) {
  console.log('Injecting additional form fields...');
  const originalInputDiv = container.querySelector('.email-input');
  originalInputDiv.querySelector('input').placeholder = 'Your email';

  const clone1 = originalInputDiv.cloneNode(true);
  clone1.querySelector('input').placeholder = 'Your phone';
  const clone2 = originalInputDiv.cloneNode(true);
  clone2.querySelector('input').placeholder = 'Your name';

  originalInputDiv.insertAdjacentElement('afterend', clone2);
  originalInputDiv.insertAdjacentElement('afterend', clone1);

  document.querySelector(config.selectors.submitButton).style.marginTop = '15px';

  if (!container.querySelector('.error-messages')) {
    const errorDiv = document.createElement('div');
    errorDiv.className = 'error-messages';
    errorDiv.style.cssText = 'color: red; font-size: 14px; margin-bottom: 10px;';
    container.insertBefore(errorDiv, container.querySelector(config.selectors.submitButton));
  }
}

//-------------------------------------------------------------------------------------
// --- Form Validation ---
//-------------------------------------------------------------------------------------
function validateForm({ email, phone, name }) {
  console.log('Validating form inputs...');
  const errors = [];
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.push('Please enter a valid email.');
  if (!/^\d{10}$/.test(phone)) errors.push('Please enter a valid 10-digit phone number.');
  if (!name || name.length < 2) errors.push('Please enter your name.');
  console.log('Validation errors:', errors);
  return errors;
}

//-------------------------------------------------------------------------------------
// --- Form Submission Handler ---
//-------------------------------------------------------------------------------------
function handleSubmit(event) {
  event.preventDefault();
  console.log('Submit button clicked. Processing form...');

  const popup = document.querySelector('.sct-popup');
  const email = popup.querySelector('input[placeholder="Your email"]').value.trim();
  const phone = popup.querySelector('input[placeholder="Your phone"]').value.trim();
  const name = popup.querySelector('input[placeholder="Your name"]').value.trim();

  console.log('Collected values:', { email, phone, name });

  const errors = validateForm({ email, phone, name });
  const errorDiv = popup.querySelector('.error-messages');
  errorDiv.innerHTML = '';

  popup.querySelectorAll('input').forEach(input => input.style.border = '');

  if (errors.length) {
    errors.forEach(err => errorDiv.innerHTML += `<div>• ${err}</div>`);
    errors.forEach(err => {
      if (err.includes('email')) popup.querySelector('input[placeholder="Your email"]').style.border = '1px solid red';
      if (err.includes('phone')) popup.querySelector('input[placeholder="Your phone"]').style.border = '1px solid red';
      if (err.includes('name')) popup.querySelector('input[placeholder="Your name"]').style.border = '1px solid red';
    });
    return;
  }

  const formData = new URLSearchParams({ name, email, phone });
  fetch(config.googleScriptURL, { method: 'POST', body: formData })
    .then(response => response.text())
    .then(data => console.log('Google Apps Script response:', data))
    .catch(err => console.error('Error sending to Google Script:', err));

  emailjs.init({ publicKey: config.emailJS.publicKey });
  emailjs.send(config.emailJS.serviceID, config.emailJS.templateID, { name, email, phone })
    .then(response => console.log('EmailJS success:', response))
    .catch(err => console.error('EmailJS error:', err));

  const formWrapper = document.querySelector(config.selectors.emailCapture);
  const top = document.querySelector(config.selectors.messageTop);
  const bottom = document.querySelector(config.selectors.messageBottom);
  top.textContent = 'Thank You';
  bottom.textContent = 'Thank you for registering for the event. You will receive confirmation email soon.';
  formWrapper.style.display = 'none';

  document.querySelector(config.selectors.closeBtn).addEventListener('click', resetFormView);
}

function resetFormView() {
  console.log('Resetting form view...');
  const formWrapper = document.querySelector(config.selectors.emailCapture);
  const top = document.querySelector(config.selectors.messageTop);
  const bottom = document.querySelector(config.selectors.messageBottom);
  top.textContent = 'Register Now';
  bottom.textContent = '#201, 23251 Fraserwood Way, Richmond';
  location.reload();
}

//-------------------------------------------------------------------------------------
// --- Button Behavior ---
//-------------------------------------------------------------------------------------
function bindRegisterNowButton() {
  const button = document.querySelector(".sct-timer-button a");
  if (!button) return;

  console.log('Binding click handler to Register Now button.');
  button.setAttribute("href", "#");
  button.addEventListener("click", (event) => {
    event.preventDefault();
    console.log('Register Now button clicked.');
    const target = document.querySelector(config.selectors.container);
    if (target) {
      target.classList.remove('out-0');
      target.classList.add('active-0');
    }
  });
}

function overrideSubmitButton() {
  console.log('Overriding submit button listeners.');
  const originalButton = document.querySelector(config.selectors.submitButton);
  if (!originalButton) return;
  const clone = originalButton.cloneNode(true);
  originalButton.replaceWith(clone);
  clone.addEventListener('click', handleSubmit);
}

//-------------------------------------------------------------------------------------
// --- Observer Setup ---
//-------------------------------------------------------------------------------------
function setupObservers() {
  // Immediately hide main popup when it appears
  waitForElement(config.selectors.popupMain, (popupMain) => {
    console.log('Main popup found. Hiding it initially.');
    popupMain.style.display = 'none';
  });

  // Immediately hide fallback popup when it appears
  waitForElement(config.selectors.popupFallback, (popupFallback) => {
    console.log('Fallback popup found. Hiding it initially.');
    popupFallback.style.display = 'none';
  });

  // Once main popup is loaded, run geolocation logic
  waitForElement(config.selectors.popupMain, async (popup) => {
    console.log('Main popup ready. Starting geolocation check...');
    const location = await getGeolocationData();
    if (
      config.targetLocation.countries.includes(location.country) &&
      config.targetLocation.regions.includes(location.region)
    ) {
      showMainPopup(popup);
    } else {
      showFallbackPopup();
    }
  });

  // Setup form behavior
  waitForElement(config.selectors.container, (container) => {
    console.log('Popup container found. Preparing form...');
    container.classList.remove('active-0');
    container.classList.add('out-0');

    const form = document.querySelector(config.selectors.emailCapture);
    injectFormFields(form);
    overrideSubmitButton();
  });
}

//-------------------------------------------------------------------------------------
// --- Init ---
//-------------------------------------------------------------------------------------
setupObservers();
